'use client';

import { usePathname } from 'next/navigation';
import JsonLd from '@/components/JsonLd';
import { getBreadcrumbSchema, SITE_URL } from '@/lib/structuredData';

// Breadcrumb schema for pages that don't build their own (services, blog posts
// and location pages render theirs in-page). Only paths listed here get one.
const LABELS: Record<string, string> = {
    '/about/': 'About Us',
    '/contact/': 'Contact',
    '/industries/': 'Industries',
    '/privacy-policy/': 'Privacy Policy',
    '/blogs/': 'Blog',
    '/services/': 'Services',
    '/our-work/': 'Our Work',
    '/our-work/case-studies/': 'Case Studies',
    '/our-work/case-studies/fashion-brand-seo/': 'Fashion Brand SEO',
    '/our-work/case-studies/healthcare-ecommerce-seo/': 'Healthcare E-commerce SEO',
    '/our-work/design1studio/': 'Design1Studio',
    '/our-work/digital-circuits/': 'Digital Circuits',
    '/our-work/koza/': 'KOZA Aesthetic Care',
    '/our-work/meta-ads/': 'Meta Ads',
    '/our-work/web-design/': 'Web Design & Development',
    '/our-work/social-media-marketing/': 'Social Media Marketing',
    '/our-work/social-media-marketing/dcpl/': 'Digital Circuits',
    '/our-work/social-media-marketing/design1studio/': 'Design1Studio',
    '/our-work/social-media-marketing/koza/': 'KOZA',
};

export default function BreadcrumbJsonLd() {
    const raw = usePathname() || '/';
    const pathname = raw.endsWith('/') ? raw : `${raw}/`;
    if (!LABELS[pathname]) return null;

    const items = [{ name: 'Home', url: `${SITE_URL}/` }];
    const segments = pathname.split('/').filter(Boolean);
    segments.forEach((_, i) => {
        const path = `/${segments.slice(0, i + 1).join('/')}/`;
        if (LABELS[path]) items.push({ name: LABELS[path], url: `${SITE_URL}${path}` });
    });

    return <JsonLd data={getBreadcrumbSchema(items)} />;
}
